// Module
var code = "<div class=\"wk-footer-copyright\"> <div role=\"contentinfo\" class=\"wk-footer-copyright-container\">© {{::currentYear}} Wolters Kluwer and/or its affiliates. All rights reserved.</div> </div>";
// Exports
module.exports = code;